import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import {
  IContact,
  IAuthentication,
  IContactInput,
  ListContactsQuery,
  ContactExistsQuery,
  GetContactByIdQuery,
  CONTACT_CONTRACTOR_MUTATION,
  CheckContractorLicense,
  AUTH_QUERY_LOGIN,
  ContactExistsDetailsQuery,
  IContactExists
} from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export class ContactGqlService  {
  currentUser: Observable<IContact>;

  constructor(private apollo: Apollo) {}

  public getContact(id: string): Observable<IContact> {
    console.log(`ContactGql.getContact()`);
    return this.apollo
      .watchQuery({
        query: GetContactByIdQuery,
        variables: {
          id: id
        }
      })
      .valueChanges.pipe(
        map(result => result.data['contact'] as IContact),
        take(1)
      );
  }

  public getContacts(): Observable<IContact[]> {
    console.log(`ContactGql.getContacts()`);
    return this.apollo
      .watchQuery({
        query: ListContactsQuery
      })
      .valueChanges.pipe(
        map(result => result.data['contacts'] as IContact[]),
        take(1)
      );
  }

  public getContactExists(email : string): Observable<boolean> {
    console.log(`ContactGql.ContactExistsQuery()`);
    return this.apollo
      .watchQuery({
        query: ContactExistsQuery,
        variables: {
          email
        }
      })
      .valueChanges.pipe(
        map(result => result.data['contactExists'] as boolean),
        take(1)
      );
  }
  
  public getContactExistDetail(email: string) : Observable<IContactExists>{
    return this.apollo.query({
        query: ContactExistsDetailsQuery,
        fetchPolicy: 'network-only',
        variables: { email: email}
      })
      .pipe(map(result => {
        if(result.data['message']) {
          return result.data['message'];
        }
        return result.data['contactExistsDetail'] as IContactExists;
      }
    ));
}
  public saveContractor(contact: IContactInput): any {
    console.log(`ContactGql.saveContractor()`);
    return this.apollo
      .mutate({
        mutation: CONTACT_CONTRACTOR_MUTATION,
        variables: {
          contact
        }
      })
      .pipe(map(result => result.data['saveContractorContact'].id as string));
  }

  public checkContractorLicense(licenseNumber: string): Observable<IContact> {
    console.log(`ContactGql.checkContractorLicense()`);
    return this.apollo
      .watchQuery({
        query: CheckContractorLicense,
        variables: {
          licenseNumber: licenseNumber
        }
      })
      .valueChanges.pipe(
        map(result => result.data['checkContractorLicense'] as IContact),
        take(1)
      );
  }

  public getAuthenticatedUser() : Observable<IAuthentication> {
    return this.apollo.query({
      query: AUTH_QUERY_LOGIN
    })
    .pipe(map(result => result.data['authentication'] as IAuthentication));
  }
}
